import styled, { css } from 'styled-components';
import { BORDER_RADIUS, CALLOUT_COLOURS, CALLOUT_FLAIR_COLOURS, COLOURS } from '@belong/themes';
import { FlairsValue, IGetCalloutStyles, MaybeStyledCSS } from '@belong/types';
import { Copy } from '../../styles/Typography/Copy/Copy';

interface ICalloutContainerProps {
  background: FlairsValue | IGetCalloutStyles;
  isSolid: boolean;
  isFullwidth?: boolean;
}

export const borderWidth = 0.2; // in rem. Used to offset the padding as well

export const CalloutContainer = styled.div<ICalloutContainerProps>`
  border-radius: ${BORDER_RADIUS.CARD};
  display: flex;
  overflow: hidden;

  ${({ background, isSolid, theme }) => {
    let bgColour;
    let borderColour;

    if (background && typeof background === 'object' && 'backgroundColor' in background) {
      bgColour = isSolid ? CALLOUT_COLOURS[background.backgroundColor] : COLOURS.WHITE;
      borderColour = CALLOUT_COLOURS[background.borderColor];
    } else if (typeof background === 'string') {
      bgColour = CALLOUT_FLAIR_COLOURS[background];
      borderColour = CALLOUT_FLAIR_COLOURS[background];
    }

    return css`
      background: ${bgColour};
      border: ${borderWidth}rem solid ${borderColour};
      padding: ${theme.spaces.xsmall - borderWidth}${theme.cssUnit};
    `;
  }}

  ${({ isFullwidth }): MaybeStyledCSS =>
    isFullwidth
      ? css`
          width: 100%;
        `
      : css`
          width: fit-content;
          max-width: 38rem;
        `}
`;

export const CalloutTitle = styled(Copy)`
  display: inline-flex;
  align-items: center;
  height: 100%;
  vertical-align: middle;
  line-height: normal;
  text-align: left; // back up for any inherited center alignment
`;

export const CalloutDescription = styled(Copy)`
  text-align: left; // back up for any inherited center alignment
  > button {
    display: block;
  }
`;
